import React, { useState } from "react";
import Swal from "sweetalert2";
import { Accordion, AccordionTab } from "primereact/accordion";
import { TabPanel, TabView } from "primereact/tabview";
import { Badge, Card as CardBootstrap } from "react-bootstrap";
import { Card } from "primereact/card";
import { formatDate } from "../../../../../utils/utils";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../../partials/content/Forms";
import Attachments from "../../../common/attachments";
import Notes from "../../../common/notes";
import DirectSalesDetail from "./directSalesDetail/directSalesDetail";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import ActivityForm from "./activityForm";
import { DialogActions } from "@material-ui/core";
import ActivityTaskForm from "./activityTaskForm";
import {
  deleteVisitActivity,
  getVisitDetail,
  updateVisitStatus,
} from "../../../../../services/crm/salesJourney";
import { useEffect } from "react";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import SalesCardForm from "../../slc/salesCardForm";
import DirectSalesForm from "./directSalesForm/directSalesForm";
import VisitEditForm from "./visitEditForm/visitEditForm";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import { isMobile } from "react-device-detect";
import parse from "html-react-parser";
function VisitDetailContent({ appCode = "SLJO", visitID = 0, history }) {
  const { reload } = useGlobalData();
  const [activeIndex, setActiveIndex] = useState(0);
  const [visitActivity, setVisitActivity] = useState({});
  const [openTaskForm, setOpenTaskForm] = useState(false);
  const [openVisitActivityForm, setOpenVisitActivityForm] = useState(false);
  const [openDirectSalesForm, setOpenDirectSalesForm] = useState(false);
  const [openDirectSalesDetail, setOpenDirectSalesDetail] = useState(false);
  const [openSalesCardForm, setOpenSalesCardForm] = useState(false);
  const [openEditVisitForm, setOpenEditVisitForm] = useState(false);
  const [journey, setJourney] = useState({});
  const [visit, setVisit] = useState({
    ID: 0,
    journeyID: 0,
    visitTo: "",
    customerID: 0,
    leadID: 0,
    customer: { customerName: "" },
    lead: { leadName: "", contactName: "" },
    planVisitDate: DateTime.now().endOf("day"),
    actVisitDate: DateTime.now(),
    visitType: 1,
    description: "",
    slcStatus: { statusName: "" },
    visitActivities: [],
  });
  const actionButtons = [];
  if (appCode === "SLJO") {
    actionButtons.push({
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/crm/journey-detail/" + visit.journeyID);
      },
    });
    if (
      visit.statusID === 1 ||
      (visit.statusID === 2 &&
        visit.visitActivities.length === 0 &&
        visit.directSalesID === 0 &&
        visit.salesCardID === 0)
    ) {
      actionButtons.push({
        title: "Cancel Visit",
        color: "danger",
        icon: "fas fa-window-close",
        onClick: () => {
          updateVisitStatusConfirm(9, "cancel");
        },
      });
    }
    if (visit.statusID === 1 && journey.statusID === 2) {
      actionButtons.push({
        title: "Start Visit",
        color: "primary",
        icon: "fas fa-flag",
        onClick: () => {
          updateVisitStatusConfirm(2, "start");
        },
      });
    }
    if (visit.statusID === 2) {
      actionButtons.push({
        title: "Finish Visit",
        color: "success",
        icon: "fas fa-flag-checkered",
        onClick: () => {
          updateVisitStatusConfirm(3, "end");
        },
      });
    }
    actionButtons.push({
      title: "Edit Visit",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        setOpenEditVisitForm(true);
      },
    });
  }
  useEffect(() => {
    getVisitDetailData(visitID);
  }, [visitID, reload]);

  return (
    <React.Fragment>
      {appCode === "SLJO" ? (
        <PageSubHeader
          title={"Visit Detail"}
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/crm/sales-journey",
              title: "Sales Journeys",
              active: false,
            },
            {
              page: "/crm/journey-detail/" + journey.ID,
              title: `Sales Journey ID ${journey.ID} ${journey.title}`,
              active: false,
            },
            {
              page: "/crm/visit-detail/" + visit.ID,
              title: `Visit ID ${visit.ID} ${
                visit.customerID > 0
                  ? visit.customer.customerName
                  : visit.leadID > 0
                  ? visit.lead.leadName
                  : ""
              }`,
              active: true,
            },
          ]}
          actionButtons={actionButtons}
        />
      ) : null}
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" renderActiveOnly={false}>
            <TabPanel header="Visit" rightIcon="fas fa-route">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <CardBootstrap>
                    <CardBootstrap.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Visit Header</strong>
                      </span>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          visit.statusID === 1
                            ? "warning"
                            : visit.statusID === 2
                            ? "primary"
                            : visit.statusID === 3
                            ? "success"
                            : visit.statusID === 9
                            ? "danger"
                            : null
                        }
                      >
                        {visit.statusID !== 0
                          ? "Visit " + visit.statusName
                          : null}
                      </Badge>
                    </CardBootstrap.Header>
                    <CardBootstrap.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {visit.customer.ID > 0 ? (
                            <CustomOutlinedDisabledTextField
                              label="Customer Name"
                              value={visit.customer.customerName}
                            />
                          ) : visit.lead.ID > 0 ? (
                            <CustomOutlinedDisabledTextField
                              label="Lead"
                              value={visit.lead.leadName}
                            />
                          ) : null}
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Plan Visit Date"
                                value={formatDate(visit.planVisitDate)}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Actual Visit Date"
                                value={formatDate(visit.actVisitDate, true)}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Visit Type"
                            value={
                              visit.visitType === 1
                                ? "In Route Visit"
                                : "Out of Route Visit"
                            }
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Description"
                            value={visit.description}
                            multiline
                            minRows={4}
                          />
                          {visit.salesCardID === 0 && visit.statusID === 2 ? (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm btn-pill btn-bold mx-1 my-3"
                              onClick={() => {
                                setOpenSalesCardForm(true);
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              New Sales Card
                            </button>
                          ) : null}
                          {visit.directSalesID === 0 &&
                          visit.customerID > 0 &&
                          visit.statusID === 2 ? (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm btn-pill btn-bold mx-1 my-3"
                              onClick={() => {
                                setOpenDirectSalesForm(true);
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              New Direct Sales
                            </button>
                          ) : null}

                          {(isMobile && journey.statusID === 1) ||
                          journey.statusID === 2 ? (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm btn-pill btn-bold mx-1 my-3"
                              onClick={() => {
                                setOpenVisitActivityForm(true);
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Activity
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </CardBootstrap.Body>
                  </CardBootstrap>
                  <br />
                  <div className="accordion">
                    <div className="card">
                      <Accordion
                        className="accordion"
                        activeIndex={activeIndex}
                        onTabChange={(e) => setActiveIndex(e.index)}
                      >
                        <AccordionTab
                          header={
                            <React.Fragment>
                              <i className="fas fa-sitemap"></i>
                              <span>
                                <strong>Visit Items</strong>
                              </span>
                            </React.Fragment>
                          }
                        >
                          {isMobile ? (
                            <React.Fragment>
                              {visit.visitActivities.map((activity, index) => (
                                <div
                                  key={index}
                                  onClick={() => {
                                    history.push(
                                      `/crm/visit-activity-tasks/${journey.ID}/${activity.ID}`
                                    );
                                  }}
                                >
                                  <Card
                                    title={
                                      activity.salesActivity.salesActivityName
                                    }
                                  >
                                    <table>
                                      <tr>
                                        <th>Status</th>
                                        <td>{activity.statusName}</td>
                                      </tr>
                                      <tr>
                                        <th>Note</th>
                                        <td>{parse(activity.note)}</td>
                                      </tr>
                                    </table>
                                  </Card>
                                </div>
                              ))}
                            </React.Fragment>
                          ) : (
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <CustomDataTable
                                  data={visit.visitActivities}
                                  onRefreshData={() => {
                                    getVisitDetailData(visitID);
                                  }}
                                  buttons={
                                    journey.statusID === 1 ||
                                    journey.statusID === 2
                                      ? [
                                          {
                                            name: "Add Activity",
                                            icon: "fas fa-plus-circle",
                                            color: "primary",
                                            onClick: () => {
                                              setOpenVisitActivityForm(true);
                                            },
                                          },
                                        ]
                                      : []
                                  }
                                  columns={[
                                    {
                                      header: "Activity",
                                      field: "salesActivity.salesActivityName",
                                      sortable: true,
                                      filter: true,
                                    },
                                    {
                                      header: "Status",
                                      field: "statusName",
                                      body: null,
                                      sortable: true,
                                      filter: true,
                                    },
                                    {
                                      header: "Note",
                                      field: "note",
                                      body: null,
                                      sortable: false,
                                      filter: true,
                                    },
                                    {
                                      header: "Actions",
                                      body: (activity) => (
                                        <React.Fragment>
                                          <BootstrapTooltip title="Activity Detail">
                                            <button
                                              type="button"
                                              className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                                              onClick={() => {
                                                //setVisitActivity(activity);
                                                //setOpenTaskForm(true);
                                                history.push(
                                                  `/crm/visit-activity-tasks/${journey.ID}/${activity.ID}`
                                                );
                                              }}
                                            >
                                              <i className="fas fa-list-alt"></i>
                                            </button>
                                          </BootstrapTooltip>
                                          <BootstrapTooltip title="Delete Activity">
                                            <button
                                              type="button"
                                              className={`btn btn-icon btn-label-danger btn-md btn-circle mx-1`}
                                              onClick={() => {
                                                deleteVisitActivityData(
                                                  activity.ID
                                                );
                                              }}
                                            >
                                              <i className="fas fa-trash-alt"></i>
                                            </button>
                                          </BootstrapTooltip>
                                        </React.Fragment>
                                      ),
                                      sortable: false,
                                    },
                                  ]}
                                />
                              </div>
                            </div>
                          )}
                        </AccordionTab>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            {visit.salesCardID > 0 ? (
              <TabPanel header="Sales Card" rightIcon="fas fa-address-card">
                <Card>
                  <Card.Header>
                    <i className="fas fa-th-large"></i>
                    <span>
                      <strong>Sales Card Basic Info</strong>
                    </span>
                  </Card.Header>
                  <Card.Body>
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="Sales Card Name"
                          value={visit.salesCard.title}
                        />
                        {visit.salesCard.customer.ID > 0 ? (
                          <React.Fragment>
                            <CustomOutlinedDisabledTextField
                              label="Customer Name"
                              value={visit.salesCard.customer.customerName}
                            />
                          </React.Fragment>
                        ) : visit.salesCard.lead.ID > 0 ? (
                          <React.Fragment>
                            <CustomOutlinedDisabledTextField
                              label="Lead Name"
                              value={visit.salesCard.lead.leadName}
                            />
                          </React.Fragment>
                        ) : null}
                        <CustomOutlinedDisabledTextField
                          label="Assigned To"
                          value={visit.salesCard.assignedUserName}
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="Currency"
                          value={visit.salesCard.currency.currencyCode}
                        />
                        <CustomOutlinedDisabledCurrencyField
                          label="Estimated Value"
                          value={visit.salesCard.estimatedValue}
                        />
                        <CustomOutlinedDisabledTextField
                          label="Sales Life Cycle Status"
                          value={visit.salesCard.slcStatus.statusName}
                        />
                      </div>
                    </div>
                    <CustomOutlinedDisabledTextField
                      label="Description"
                      value={visit.salesCard.description}
                      multiline
                      minRows={5}
                    />
                  </Card.Body>
                </Card>
              </TabPanel>
            ) : (
              <TabPanel
                header="Sales Card"
                rightIcon="fas fa-address-card"
                disabled
              ></TabPanel>
            )}
            {visit.directSalesID > 0 && visit.customerID > 0 ? (
              <TabPanel header="Direct Sales" rightIcon="fas fa-people-carry">
                <DirectSalesDetail directSalesID={visit.directSalesID} />
              </TabPanel>
            ) : (
              <TabPanel
                header="Direct Sales"
                rightIcon="fas fa-people-carry"
                disabled
              ></TabPanel>
            )}
            <TabPanel header="Attachments" rightIcon="fas fa-paperclip">
              <Attachments docType="VIST" docID={visit.ID} />
            </TabPanel>
            <TabPanel header="Notes" rightIcon="fas fa-sticky-note">
              <Notes docType="VIST" docID={visit.ID} />
            </TabPanel>
          </TabView>
        </div>
      </div>

      <DialogLayout
        open={openVisitActivityForm}
        title="Visit Activity Form"
        onCloseDialog={() => {
          setOpenVisitActivityForm(false);
        }}
        maxWIdth="md"
      >
        <ActivityForm
          visit={visit}
          onConfirmSave={() => {
            getVisitDetailData(visit.ID);
            setOpenVisitActivityForm(false);
          }}
          onCloseDialog={() => {
            setOpenVisitActivityForm(false);
          }}
        />
      </DialogLayout>

      <DialogLayout
        open={openTaskForm}
        title={`Visit Activity ${visitActivity.activityName} Tasks`}
        onCloseDialog={() => {
          setOpenTaskForm(false);
        }}
        maxWIdth="lg"
      >
        <ActivityTaskForm
          journeyID={visit.journeyID}
          visitActivity={visitActivity}
          onCloseDialog={() => {
            setOpenTaskForm(false);
          }}
          onConfirmSave={() => {
            getVisitDetailData(visitID);
            setOpenTaskForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openEditVisitForm}
        title="Edit Visit Form"
        onCloseDialog={() => {
          setOpenEditVisitForm(false);
        }}
        maxWIdth="md"
      >
        <VisitEditForm
          visit={visit}
          onCloseDialog={() => {
            setOpenEditVisitForm(false);
          }}
          onConfirmSave={() => {
            getVisitDetailData(visitID);
            setOpenEditVisitForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openDirectSalesDetail}
        maxWIdth="lg"
        title="Direct Sales Detail"
        onCloseDialog={() => {
          setOpenDirectSalesDetail(false);
        }}
        fullScreen={false}
      >
        <DirectSalesDetail directSalesID={visit.directSalesID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenDirectSalesDetail(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openDirectSalesForm}
        maxWIdth="xl"
        title="Direct Sales Form"
        onCloseDialog={handleCloseDirectSalesForm}
        fullScreen={false}
      >
        <DirectSalesForm
          salesID={journey.salesID}
          visit={visit}
          onCloseDialog={handleCloseDirectSalesForm}
          onConfirmSave={(salesData) => {
            handleCloseDirectSalesForm();
            getVisitDetailData(visitID);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSalesCardForm}
        title="Sales Card Form"
        maxWIdth="sm"
        onCloseDialog={handleCloseSalesCardForm}
      >
        <SalesCardForm
          visit={visit}
          onCloseDialog={handleCloseSalesCardForm}
          onConfirmSave={() => {
            handleCloseSalesCardForm();
            getVisitDetailData(visitID);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function deleteVisitActivityData(activityID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Activity ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteVisitActivity(activityID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getVisitDetailData(visit.ID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
  async function getVisitDetailData(visitID = 0) {
    const response = await getVisitDetail(visitID);
    const { data } = response.data;
    //setVisit(data.visit);
    setJourney(data.journey);
  }

  function updateVisitStatusConfirm(statusID = 0, action = "") {
    if (
      statusID === 3 &&
      visit.visitActivities.length === 0 &&
      visit.directSalesID === 0 &&
      visit.salesCardID === 0
    ) {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      }).fire({
        title: "Failed",
        text: "Cannot finish Visit with no activities",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
      });
    } else {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
          cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      })
        .fire({
          title: "Are you sure want to " + action + " this Visit ?",
          text: "Please note that you are responsible for this action",
          icon: "question",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText:
            `<i class="fas fa-check-circle"></i> Yes, ` + action + ` it`,
          cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            const visitUpdate = { ...visit };
            visitUpdate.statusID = statusID;
            updateVisitStatus(visitUpdate).then((response) => {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Saved",
                html: response.data.message,
                icon: "success",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              getVisitDetailData(visitID);
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Cancelled",
              text: "No change has been made",
              icon: "info",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        });
    }
  }
  function handleCloseDirectSalesForm() {
    setOpenDirectSalesForm(false);
  }
  function handleCloseSalesCardForm() {
    setOpenSalesCardForm(false);
  }
}

export default VisitDetailContent;
